export class FailedSolutionIdExchange extends Error {
  constructor(...params) {
    var _Error$captureStackTr;
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    (_Error$captureStackTr = Error.captureStackTrace) === null || _Error$captureStackTr === void 0 ? void 0 : _Error$captureStackTr.call(Error, this, FailedSolutionIdExchange);
  }
  /*LWC compiler v7.1.3*/
}